import React, {FC} from 'react';

import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';

import s from '../baseProductItems.scss';

import {BaseLensesColorBlock} from './baseLensesColorBlock/baseLensesColorBlock';

export type PropsType = {
    item: QuoteItemV2;
    nameComponent: React.ReactNode;
    removeComponent?: React.ReactNode;
    children?: React.ReactNode;
};

/**
 * Base Product Contact lenses Item
 */
export const BaseLensesProductItem: FC<PropsType> = ({
    children,
    item,
    nameComponent,
    removeComponent,
}) => {
    const {prescription, product, rowTotalDiscountedPriceWithoutTax, totalPrice} = item;
    const isColored = Boolean(prescription?.od?.color || prescription?.os?.color);
    const hasDiscount = totalPrice > rowTotalDiscountedPriceWithoutTax;

    return (
        <div className={s.topBar}>
            <div className={s.topBarContent}>
                <div className={s.imageBlock}>
                    <CloudinaryImage
                        alt={item.name}
                        className={s.image}
                        src={item.product.image}
                        width="100%"
                    />
                </div>
                <div className={s.shortDetails}>
                    {nameComponent}
                    <BaseLensesColorBlock prescription={prescription} />
                    <div
                        className={classNames(s.priceBlock, s.inContactLenses, {
                            [s.noColor]: !isColored,
                        })}
                    >
                        {hasDiscount && (
                            <>
                                <span className={classNames(s.price, s.regular)}>
                                    <Price>{totalPrice}</Price>
                                </span>
                                &nbsp;
                            </>
                        )}
                        <span className={classNames(s.price)}>
                            <Price>{rowTotalDiscountedPriceWithoutTax}</Price>&nbsp;
                        </span>
                        <span className={s.perBoxPrice}>
                            (per box{' '}
                            {hasDiscount && (
                                <>
                                    <span className={classNames(s.price, s.regular)}>
                                        <Price>{product.finalPrice}</Price>
                                    </span>
                                    &nbsp;&nbsp;
                                </>
                            )}
                            <Price>{item.discountedPrice}</Price>)
                        </span>
                    </div>
                    {children}
                </div>
            </div>
            {removeComponent}
        </div>
    );
};
